module.exports = __webpack_public_path__ + "img/65.bfb8ec94.jpg";